import { z } from 'zod';

// ---------------------------------------------------------------------------
// Newsletter event payload schemas
// ---------------------------------------------------------------------------

/** Emitted by api after insert/upsert — worker sends confirmation email. */
export const newsletterConfirmRequestedSchema = z.object({
  email: z.string().email(),
  lang_code: z.string(),
  confirm_url: z.string().url(),
});
export type NewsletterConfirmRequestedPayload = z.infer<typeof newsletterConfirmRequestedSchema>;

/** Emitted by api after confirm token validated — worker sends welcome email. */
export const newsletterWelcomeRequestedSchema = z.object({
  email: z.string().email(),
  lang_code: z.string(),
  unsubscribe_url: z.string().url(),
});
export type NewsletterWelcomeRequestedPayload = z.infer<typeof newsletterWelcomeRequestedSchema>;
